import "./reset_password.css";
import Logo1 from "../../assets/icons/logo1";
import Logo from "../../assets/icons/logo";
import { useEffect } from "react";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
import OtpInput from "react-otp-input";
import { IoIosArrowBack } from "react-icons/io";
import useAuth from "../../hooks/use_auth";
import { useNavigate } from "react-router-dom";
import Countdown, { zeroPad } from "react-countdown";

const ResetPassword = () => {
  const navigate = useNavigate();
  const {
    // entity methods
    resendVerificationCode,
    // controller methods
    forgotPasswordController,
    resetPasswordController,
    // controller states
    forgotPasswordStep,
    setForgotPasswordStep,
    now,
    setNow,
    showReset,
    setShowReset,
    // loading states
    loadings,
  } = useAuth();

  const renderer = ({ minutes, seconds }) => {
    return (
      <div className={"time_resend_code"}>
        <span
          className="font_medium"
          style={
            showReset ? { color: "var(--second)" } : { color: "var(--blue)" }
          }
        >
          {zeroPad(minutes)} : {zeroPad(seconds)}
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="reset_password">
      {/* reset_password_container */}
      <div className="reset_password_container">
        <div className="logo">
          <Logo1 />
        </div>
        {forgotPasswordStep == 2 ? (
          <div className="back_btn_mobile">
            <Button onClick={() => setForgotPasswordStep(1)}>
              <IoIosArrowBack />
            </Button>
          </div>
        ) : null}

        {/* logo_mobile */}
        <div className="logo_mobile">
          <Logo />
        </div>
        {/* forgot_password */}
        {forgotPasswordStep == 1 ? (
          <form
            onSubmit={forgotPasswordController.handleSubmit}
            className="forgot_password"
          >
            <h3>Forgot password</h3>
            <p>To reset your password, please provide your email address</p>
            <Input
              name="email"
              id="email"
              value={forgotPasswordController.values.email}
              onChange={forgotPasswordController.handleChange}
              status={
                forgotPasswordController.touched.email &&
                forgotPasswordController.errors.email
                  ? "error"
                  : ""
              }
              disabled={
                loadings.forgotPasswordInstructorCheck ||
                loadings.forgotPasswordCheckEmail ||
                loadings.forgotPassword
              }
              placeholder="Email"
            />
            <Button
              htmlType="submit"
              className="reset_password_btn"
              loading={
                loadings.forgotPasswordInstructorCheck ||
                loadings.forgotPasswordCheckEmail ||
                loadings.forgotPassword
              }
            >
              <span>Check Email</span>
            </Button>
            <div
              onClick={() => {
                navigate("/login");
              }}
              style={{
                color: "var(--blue)",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                marginTop: 24,
              }}
              className="font-medium"
            >
              Back to login
            </div>
          </form>
        ) : null}
        {/* confirmation_code */}
        {forgotPasswordStep == 2 ? (
          <form
            onSubmit={resetPasswordController.handleSubmit}
            className="confirmation_code"
          >
            <h3>Confirm email and reset password</h3>
            <p>
              We sent a verification code to{" "}
              {resetPasswordController.values.email.slice(0, 3)}...@
              {resetPasswordController.values.email.split("@")[1]} Enter the
              4-digit code you received via email and enter your new password.
            </p>
            {/* otp_container */}
            <div className="otp_container">
              <OtpInput
                shouldAutoFocus
                value={resetPasswordController.values.code}
                onChange={(otp) =>
                  resetPasswordController.setFieldValue("code", otp)
                }
                onBlur={resetPasswordController.handleBlur("code")}
                className={`otpInput ${
                  resetPasswordController.touched.code &&
                  resetPasswordController.errors.code
                    ? "errorBorder"
                    : ""
                }`}
                numInputs={4}
                maxLength={4}
                inputMode="numeric"
                renderSeparator={<span style={{ width: "16px" }} />}
                renderInput={(props) => (
                  <input
                    {...props}
                    type="tel"
                    inputMode="tel"
                    autocomplete="tel"
                    disabled={
                      loadings.resetPassword || loadings.resendVerificationCode
                    }
                    pattern="[0-9]*"
                    style={{
                      width: "60px",
                      height: "60px",
                      fontSize: "18px",
                      borderRadius: "8px",
                      border:
                        resetPasswordController.touched.code &&
                        resetPasswordController.errors.code
                          ? "1px solid #ff4d4f"
                          : "1px solid var(--line)",
                      textAlign: "center",
                      outline: "none",
                    }}
                  />
                )}
                focusStyle={{
                  border: "1px solid transparent",
                  boxShadow: "none",
                }}
              />
            </div>
            <div className="new_password">
              {/* password */}
              <Input.Password
                name="password"
                placeholder="Enter your new password"
                disabled={
                  loadings.resetPassword || loadings.resendVerificationCode
                }
                value={resetPasswordController.values.password}
                onChange={resetPasswordController.handleChange}
                status={
                  resetPasswordController.touched.password &&
                  resetPasswordController.errors.password
                    ? "error"
                    : ""
                }
              />
              <Input.Password
                name="password_confirm"
                placeholder="Re-enter password"
                value={resetPasswordController.values.password_confirm}
                onChange={resetPasswordController.handleChange}
                disabled={
                  loadings.resetPassword || loadings.resendVerificationCode
                }
                status={
                  resetPasswordController.touched.password_confirm &&
                  resetPasswordController.errors.password_confirm
                    ? "error"
                    : ""
                }
              />
            </div>
            <Button
              loading={loadings.resetPassword}
              htmlType="submit"
              className="confirmation_code_btn"
            >
              <span>Verify Code</span>
            </Button>
            <div className={"time_container"}>
              {showReset == true ? (
                <div className={"timer"}>
                  <div className={"time_resend_code"}>
                    <span
                      className="font_medium"
                      style={
                        showReset
                          ? { color: "var(--second)" }
                          : { color: "var(--gary_50)" }
                      }
                    >
                      00 : 00
                    </span>
                  </div>
                </div>
              ) : (
                <div className={"timer"}>
                  <Countdown
                    date={now}
                    zeroPadTime={2}
                    precision={3}
                    renderer={renderer}
                    onComplete={() => {
                      setShowReset(true);
                      setNow(null);
                    }}
                  />
                </div>
              )}
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "14px",
                  color: "var(--text)",
                }}
              >
                Haven't got the email yet?
                <span
                  style={
                    loadings.resendVerificationCode
                      ? {
                          color: showReset ? "var(--blue)" : "var(--gary_50)",
                          textDecoration: "underline",
                          cursor: "not-allowed",
                          marginLeft: "5px",
                          filter: "blur(1.5px)",
                        }
                      : {
                          color: showReset ? "var(--blue)" : "var(--gary_50)",
                          textDecoration: "underline",
                          cursor: showReset ? "pointer" : "not-allowed",
                          marginLeft: "5px",
                        }
                  }
                  onClick={() => {
                    if (showReset == true) {
                      resendVerificationCode(
                        resetPasswordController.values.email,
                        2,
                      );
                    }
                  }}
                >
                  Resend email
                </span>
              </div>
            </div>
          </form>
        ) : null}
        {/* new_password */}
        {forgotPasswordStep == 3 ? (
          <form className="new_password">
            <h3>Set a new password</h3>
            <p>
              For security reasons, please ensure your new password differs from
              previous ones.
            </p>

            <Button htmlType="submit" className="update_password_btn">
              <span>Update Password</span>
            </Button>
          </form>
        ) : null}
      </div>
    </div>
  );
};
export default ResetPassword;
